var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cta-button",attrs:{"buttonType":_vm.formSubmissionButton ? 'submit' : 'button'},on:{"click":() => {
			if (_vm.routeName !== 'doNotPushToNewRoute') {
				return _vm.$router.push({ name: `${_vm.routeName}` });
			}
		}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }